import { Home } from '../home/Home';
import type { Locale } from '../i18n/locale';

/** Public HOME (docs/phase-0/03 sequence), es-CO at / and English at /en/. */
export function HomePage({ locale = 'es-CO' }: { locale?: Locale }) { return <Home locale={locale} />; }
